import { render, staticRenderFns } from "./proprietorLogoManageEdit.vue?vue&type=template&id=077b6551&"
import script from "./proprietorLogoManageEdit.vue?vue&type=script&lang=js&"
export * from "./proprietorLogoManageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports